export const formatPhoneNumber = (phoneNumber: string): string => {
  const phoneNumberWithoutPrefix = phoneNumber.startsWith("+1")
    ? phoneNumber.replace("+1", "")
    : phoneNumber.startsWith("1")
      ? phoneNumber.substring(1)
      : phoneNumber;

  const areaCode = phoneNumberWithoutPrefix.substring(0, 3);
  const exchangeNumber = phoneNumberWithoutPrefix.substring(3, 6);
  const number = phoneNumberWithoutPrefix.substring(6);

  return `(${areaCode}) ${exchangeNumber}-${number}`;
};
